// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__kZTvp","ToolbarLogo":"Toolbar_ToolbarLogo__3Jq2h","DesktopOnly":"Toolbar_DesktopOnly__2lNw5"};